// extracted by mini-css-extract-plugin
module.exports = {"orderContainer":"order_orderContainer__14Itv","orderNumber":"order_orderNumber__2ukn_","orderNotFound":"order_orderNotFound__2256d"};